
import AiTabs from '../ai-tabs.vue'
import AiAgents from '../ai-agents.vue'
import Research from './research'
import Sources from 'components/sources'

export default {
  components: {
    AiTabs,
    Research,
    AiAgents,
    Sources
  },
  props: {
    chatId: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    sources: {
      type: Array,
      default: () => []
    },
    lastAnswer: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      tab: 'agents'
    }
  },
  computed: {
    active_tab: {
      get(){
        if (!this.completed) return 'tasks'
        return this.tab
      },
      set(val){
        if (!this.completed) return
        this.tab = val
      }
    },
    tabs(){
      return [
        {title: 'Agents', value: 'agents'},
        {title: 'Sources', value: 'sources'},
        {title: 'Steps', value: 'tasks'}
      ]
    },
    reasoning(){
      const reasoning = this.item.data?.reasoning
      if (reasoning?.length > 0) {
        return reasoning
      }
      
      const status = this.item.data?.status
      if (status) {
        return [status]
      }

      return undefined
    },
    ai_question() {
      const entry = this.reasoning?.at(-1)
      return entry && entry.input && !entry.answer
    },
    completed() {
      // reasoning for previous answers is always completed
      if (!this.lastAnswer) return true

      // reasoning while we're still generating is not completed
      if (this.loading) return false

      // reasoning with ai question is not completed
      if (this.ai_question) return false
      
      return true
    },
  },
  watch: {
    loading() {
      if (this.loading) return
      if (this.completed) this.tab = 'agents'
    }
  }
}
